import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: function(lngs, namespaces) { return '/locales/{{lng}}.json'; },
    },
    detection: {
        order: ['navigator', 'querystring', 'cookie', 'localStorage', 'sessionStorage', 'htmlTag', 'path', 'subdomain'],
    }
  });

export default i18n;
